// WhatsApp helper - format nomor & pesan otomatis
export const WA_NUMBER_LOCAL = "089653989366";
export const WA_NUMBER_INTL = "6289653989366"; // Format internasional untuk wa.me

export const formatIDR = (n) =>
  new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    maximumFractionDigits: 0,
  }).format(n);

export const buildWaLink = (motorName, extra = "") => {
  const base = `Halo, saya tertarik dengan Yamaha ${motorName}.`;
  const text = extra ? `${base} ${extra}` : `${base} Mohon info harga OTR Kalimantan Barat, promo terbaru, dan simulasi kredit. Terima kasih.`;
  return `https://wa.me/${WA_NUMBER_INTL}?text=${encodeURIComponent(text)}`;
};

export const buildWaLinkGeneric = (msg) => {
  return `https://wa.me/${WA_NUMBER_INTL}?text=${encodeURIComponent(msg)}`;
};
